module.exports = __webpack_public_path__ + "static/img/splash-top-sm.a48a9bd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/splash-top-sm.jpg
// module id = x6Z2
// module chunks = 0